<template>
  <div>
    <div class="text-xs-right">
      <v-btn icon @click="$emit('close')"><v-icon>close</v-icon></v-btn>
    </div>
    <div class="px-5 pb-4">
      <div class="primary--text mb-4" style="font-size: 19px">จัดกลุ่มเพจ/LINE OA/Instagram</div>
      <div>
        <div>เลือกกลุ่ม</div>
        <div class="form-control" :class="{ 'has-error': errors.has('กลุ่ม') }">
          <multiselect
            name="กลุ่ม"
            multiple
            track-by="name"
            v-validate="'required'"
            v-model="input.group"
            label="name"
            :loading="loading"
            :options="groupOptions"
          ></multiselect>
          <p class="text-error" v-if="errors.has('กลุ่ม')">
            {{ errors.first('กลุ่ม') }}
          </p>
        </div>
        <div class="mt-3">กรอก Signature</div>
        <div class="form-control" :class="{ 'has-error': errors.has('Signature') }">
          <AutoresizeTextarea
            name="Signature"
            type="text"
            v-validate="'required'"
            v-model="input.signature"
            :maxlength="channel == 'instagram' ? 1200 : 9999"
          ></AutoresizeTextarea>
          <template v-if="channel == 'instagram'">
            <div class="text-xs-right">
              {{ input.signature ? input.signature.length : 0 }} / 1200
            </div>
          </template>

          <p class="text-error" v-if="errors.has('Signature')">
            {{ errors.first('Signature') }}
          </p>
        </div>
        <div class="text-xs-center">
          <v-btn @click="$emit('close')" outline color="grey">cancel</v-btn>
          <v-btn :loading="saveloading" @click="onSave" depressed color="primary">save</v-btn>
        </div>
      </div>
    </div>
    <v-dialog v-model="showLineModal" width="600px" persistent>
      <v-card class="pa-4">
        <v-snackbar v-model="showCopy" :timeout="6000" color="green" :top="true"
          >{{ $t('Link Copied') }}!</v-snackbar
        >

        <div class="form-control">
          <label for>Webhook Url</label>
          <div class="row" style="margin-bottom: 0">
            <div class="col s12 m9">
              <textarea
                class="form-control"
                ref="shareLink"
                style="resize: vertical; min-height: 90px; background: #eee"
                onclick="this.select()"
                readonly="true"
                v-model="webhookUrl"
              ></textarea>
            </div>
            <div class="left-align col s12 m3">
              <a
                href="javascript:void(0);"
                class="btn btn-outline-red"
                v-clipboard:copy="webhookUrl"
                v-clipboard:success="onCopy"
                v-clipboard:error="onError"
                style="position: relative"
              >
                <span class="fas fa-copy"></span>
                {{ $t('copy') }}
                <transition
                  enter-active-class="animated fadeInUp"
                  leave-active-class="animated fadeOut"
                ></transition>
              </a>
            </div>
          </div>
          <div>
            <div class="text-xs-center">
              <v-btn @click="$emit('onsave')" depressed color="primary">Close</v-btn>
            </div>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from '@/api'
import AutoresizeTextarea from '@/components/elements/AutoresizeTextarea.vue'
import multiselect from 'vue-multiselect'
import { mapGetters } from 'vuex'
export default {
  props: ['edittype', 'editdata', 'groupOptions', 'channel'],
  computed: {
    ...mapGetters(['selectedBot'])
  },
  components: {
    multiselect,
    AutoresizeTextarea
  },
  data() {
    return {
      showCopy: false,
      webhookUrl: '',
      input: {
        group: '',
        signature: ''
      },
      showLineModal: false,
      saveloading: false,
      loading: false
    }
  },
  mounted() {
    if (this.editdata) {
      this.webhookUrl = `https://communitybotbyzwizai.herokuapp.com/webhookline?facebookpageid=${this.editdata.channelid}`
      if (this.editdata.groupids) {
        var groupids = this.editdata.groupids.map((el) => el)
        this.input.group = this.groupOptions.filter((el) => groupids.includes(parseInt(el.id)))
      }
      if (this.editdata.signature) {
        this.input.signature = this.editdata.signature
      }
    }
  },
  methods: {
    onCopy: function () {
      let vm = this
      vm.showCopy = true
      setTimeout(() => {
        vm.showCopy = false
      }, 1000)
    },
    onError: function () {},
    async onSave() {
      if (await this.$validator.validate()) {
        this.saveloading = true
        var data = {
          pageid: this.selectedBot.pageid, // pageid ที่เข้ามาจาก cms
          channelId: this.editdata.channelid, // channelid ที่ได้จาก response STEP 3
          groupId: this.input.group.map((el) => el.id),
          signature: this.input.signature
        }
        api.powerbuyAddChannelGroup(data, (err, response) => {
          this.saveloading = false
          if (response.responsecode == 200) {
            if (this.edittype == 'line') {
              this.showLineModal = true
            } else {
              this.$emit('onsave')
            }
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/powerbuy/Management/ChannelManagerEdit.vue